<template>
    <div class="col-sm-12 data-list-content">
        <slot :items="items" :loading="loading" :order-by="orderBy"></slot>
        <div class="text-center">
            <div class="custom-pagination" v-if="shouldShowPagination">
                <div class="row">
                    <div class="btn-left">
                        <button class="btn btn-outline-secondary btn-block"
                                v-show="enabledPrevPageButton"
                                @click="fetchPrevPage">
                            <i class="fa fa-angle-left"></i>
                        </button>
                    </div>
                    <div class="btn-right">
                        <button class="btn btn-outline-secondary btn-block"
                                v-show="enabledNextPageButton"
                                @click="fetchNextPage">
                            <i class="fa fa-angle-right"></i>
                        </button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>


  export default {
    props: {
      dataSource: {
        type: String,
      },

      identifier: {
        default: '',
      },

      urlCreate: {
        type: String,
        default() {
          return null;
        },
      },

      deleteMessage: {
        type: String,
        default() {
          return 'Tem certeza que deseja apagar este registro?';
        },
      },

      resendMessage: {
        type: String,
        default() {
          return 'Tem certeza que deseja reenviar este e-mail?'
        },
      },

      undeleteMessage: {
        type: String,
        default() {
          return 'Tem certeza que deseja restaurar este usuário?'
        },
      },

      deleteTitle: {
        type: String,
        default() {
          return 'Excluir registro';
        },
      },

      resendTitle: {
        type: String,
        default() {
          return 'Reenviar e-mail';
        },
      },

      undeleteTitle: {
        type: String,
        default() {
          return 'Restaurar';
        },
      },
    },

    watch: {
      dataSource() {
        this.fetchData();
      },

      query: _.debounce(function (text) {
        this.currentPage = 1;
        this.fetchData();
      }, 350),

      'filters.status': function () {
        this.setFilter('status', this.filters.status);
        this.fetchData();
      },
    },

    computed: {
      queryFilters() {
        let query_filters = '';
        for (var filterName in this.filters) {
          if (this.filters.hasOwnProperty(filterName)) {
            query_filters += '&' + filterName + '=' + this.filters[filterName];
          }
        }
        return query_filters;
      },

      fetch_url() {
        let query_params = '';
        query_params = (!(this.dataSource.slice(-1) === '&') ? '?' : '') + 'query=' + this.query;
        query_params += '&field=' + this.field;
        query_params += '&order=' + this.order;

        if (this.currentPage != 1) {
          query_params += '&page=' + this.currentPage;
        }

        query_params += this.queryFilters;

        const url = this.dataSource + query_params;
        return encodeURI(url);
      },

      no_results() {
        return typeof this.items == 'undefined' || this.items.length == 0;
      },

      enabledNextPageButton() {
        return this.currentPage < this.totalPages;
      },

      enabledPrevPageButton() {
        return this.currentPage > 1;
      },

      shouldShowPagination() {
        return this.totalPages > 1;
      },

      isNotLoading() {
        return !this.loading;
      },
    },

    data: function () {
      return {
        items: [],

        loading: true,

        query: '',
        field: '',
        order: 'desc',

        totalPages: 1,
        currentPage: 1,
        itemsPerPage: 15,

        count: {
          actives: 0,
          inactives: 0,
        },

        filters: {}
      }
    },

    mounted() {
      this.listenFilters();
      this.listenLoadingEvents();
      this.fetchData();
      this.$root.$on('reload-data', () => this.fetchData());
    },

    methods: {
      orderBy(field, event) {
        this.field = field;
        this.toggleOrder();
        this.setOrderArrowIn(event.target);
        this.fetchData();
      },

      toggleOrder() {
        this.order = (this.order == 'asc') ? 'desc' : 'asc';
        return this.order;
      },

      setOrderArrowIn(element) {
        let defaultClass = '.order-arrow';
        let classToRemove = $(element).attr('class');

        let toQuery = classToRemove ? `.${classToRemove} > .order-arrow` : defaultClass;

        let arrows = Array.from(document.querySelectorAll(toQuery));

        arrows.forEach((node) => {
          node.parentNode.removeChild(node);
        });

        element.appendChild(this.getArrow());
      },

      getArrow() {
        let arrow_classes = '';
        if (this.order == 'asc') {
          arrow_classes = 'fa fa-angle-up order-arrow'
        } else {
          arrow_classes = 'fa fa-angle-down order-arrow'
        }

        const arrow = document.createElement('i');
        arrow.className = arrow_classes;

        return arrow;
      },

      getRef(ref) {
        return this.$refs[ref];
      },

      setPagination(fetched_data) {
        if (typeof fetched_data !== 'undefined') {
          this.totalPages = fetched_data.last_page;
          this.currentPage = fetched_data.current_page;
          this.itemsPerPage = fetched_data.per_page;
        }
      },

      fetchData() {
        this.$root.$emit('start-loading');
        const localQuery = this.query;
        axios.get(this.fetch_url).then((response) => {
          if (localQuery === this.query) {
            this.items = response.data.data;
            this.setPagination(response.data);
            this.$root.$emit('stop-loading');
            this.$nextTick().then(function () {
              let div = $('[data-toggle="popover"]')
              if (div)
                div.popover();
            });
          }
        });
      },

      fetchPrevPage() {
        if (this.enabledPrevPageButton) {
          this.currentPage = this.currentPage - 1;
          this.fetchData();
        }
      },

      fetchNextPage() {
        if (this.enabledNextPageButton) {
          this.currentPage = this.currentPage + 1;
          this.fetchData();
        }
      },

      handleDelete(link) {
        axios.delete(link).then((response) => {
          const status = response.data;
          if (status.type) {
            this.$snotify[status.type](status.message);
            this.fetchData();
          } else {
            this.$snotify.error('Action undefined');
          }
        });
      },

      handleResendEmail(link) {
        axios.get(link).then((response) => {
          const status = response.data;
          if (status.type) {
            this.$snotify[status.type](status.message);
            this.fetchData();
          } else {
            this.$snotify.error('Action undefined');
          }
        });
      },

      activate(link) {
        axios.post(link).then((response) => {
          const status = response.data;
          if (status.type) {
            this.$snotify[status.type](status.message);
            $('.tooltip').remove();
            this.fetchData();
          } else {
            this.$snotify.error('Action undefined');
          }
        });
      },

      deactivate(link) {
        axios.post(link).then((response) => {
          const status = response.data;
          if (status.type) {
            this.$snotify[status.type](status.message);
            $('.tooltip').remove();
            this.fetchData();
          } else {
            this.$snotify.error('Action undefined');
          }
        });
      },

      confirmDelete(link, message = undefined) {
        if (message == undefined) {
          message = this.deleteMessage;
        }

        this.$snotify.confirm(message, this.deleteTitle, {
          timeout: 5000,
          showProgressBar: false,
          closeOnClick: true,
          pauseOnHover: false,
          buttons: [
            {text: 'Sim', action: () => this.handleDelete(link), bold: false},
            {text: 'Não'},
          ]
        });
      },

      listenFilters() {
        this.$on('setFilter', (payload) => {
          this.setFilter(payload.urlKey, payload.value);
          this.fetchData();
        });
      },

      setFilter(name, value) {
        if (value) {
          this.$set(this.filters, name, value)
        } else {
          delete this.filters[name];
          this.filters = _.assign({}, this.filters);
        }
      },

      listenLoadingEvents() {
        this.$root.$on('start-loading', () => {
          this.loading = true;
        });

        this.$root.$on('stop-loading', () => {
          this.loading = false;
        });
      },
    },
  }
</script>
<style scoped>
    .btn-outline-secondary {
        background-color: transparent;
        color: #0dbbba;
    }

    .btn-left {
        position: absolute;
        left: 0;
    }

    .btn-right {
        position: absolute;
        right: 0;
    }
</style>


// WEBPACK FOOTER //
// resources/assets/js/components/HorizontalDataList.vue